<template>
  <div>
    <el-alert type="info" :closable="false" title="此组件为固定字段结构，无法自定义列"></el-alert>
  </div>
</template>

<script>
export default {
  name: 'PurchaseGoodsList',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>

</style>


